import { Confetti } from 'components/Confetti/Confetti'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

export const ConfettiWrapper = observer(() => {
  const confetti = useRootStore().confettiStore

  if (!confetti.shown) return null

  return <Confetti onConfettiComplete={() => confetti.hide()} />
})
